import { IconButton, Stack, Typography, styled } from "~/common/mui";
import { PopperTooltip } from "~/common/components/Tooltip";
import { useTranslation } from "react-i18next";
import { IMG_DMC_TEASER } from "~/utils/url/staticResources";
import { C_ON_SURFACE_VARIANT } from "~/common/components/icon/Colors";
import QrCodeScannerOutlinedIcon from "@mui/icons-material/QrCodeScannerOutlined";
import classNames from "classnames";
import { resetQualtrics } from "~/common/utils/misc";

const StyledTooltip = styled(Stack)(({ theme }) => ({
  background: theme.palette.surface.main,
  width: 408,
  padding: theme.spacing(3),
  paddingTop: theme.spacing(4),
  fontSize: theme.typography.bodyLarge.fontSize,
  lineHeight: theme.typography.bodyLarge.lineHeight,
  letterSpacing: theme.typography.bodyLarge.letterSpacing,
  "& fieldset": {
    display: "flex !important",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  "& .QSI__EmbeddedFeedbackContainer": {
    display: "contents",
  },
  "& .QSI__EmbeddedFeedbackContainer_QuestionText": {
    fontSize: `${theme.typography.bodyLarge.fontSize} !important`,
    lineHeight: `${theme.typography.bodyLarge.lineHeight} !important`,
    letterSpacing: `${theme.typography.bodyLarge.letterSpacing} !important`,
  },
}));

const StyledImage = styled("img")({
  width: 260,
  alignSelf: "center",
});

interface Props {
  className?: string;
}

export const DesktopScanDMCTeaser = (props: Props) => {
  const { t } = useTranslation();
  return (
    <PopperTooltip
      placement={"bottom"}
      innerClassName={"p-0"}
      tooltipContent={
        <StyledTooltip gap={3} className={classNames(props.className)}>
          <Typography variant="bodyLarge" sx={{ margin: 0, fontWeight: "bold" }}>
            {t("qualtrics.scandmc.title")}
          </Typography>
          <Typography variant="bodyLarge">{t("qualtrics.scandmc.paragraph.1")}</Typography>
          <StyledImage src={IMG_DMC_TEASER} />
          <Stack gap={2}>
            <div id={"qualtricsScanning"} />
          </Stack>
        </StyledTooltip>
      }
      onTooltipOpened={resetQualtrics}
    >
      <IconButton sx={{ color: C_ON_SURFACE_VARIANT }}>
        <QrCodeScannerOutlinedIcon />
      </IconButton>
    </PopperTooltip>
  );
};
